import classNames from 'classnames';
import React, { Component } from 'react';
import './Form.scss';

export const FormContext = React.createContext();

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstInvalidField: null,
            inputFields: {},
            invalidInputFields: [],
        };

        this.clear = this.clear.bind(this);
        this.onValidateHandler = this.onValidateHandler.bind(this);
        this.validate = this.validate.bind(this);
    }

    clear() {
        const { inputFields } = this.state;
        Object.keys(inputFields).forEach((name) => inputFields[name].clearValue());
        this.validate(false);
    }

    onValidateHandler(name, isValid) {
        this.setState(
            (state) => {
                let nextInvalidInputFields = state.invalidInputFields.slice();

                if (!isValid) {
                    nextInvalidInputFields = nextInvalidInputFields.filter(
                        (invalidFieldName) => invalidFieldName !== name
                    );
                    nextInvalidInputFields.push(name);
                } else {
                    nextInvalidInputFields = nextInvalidInputFields.filter(
                        (invalidFieldName) => invalidFieldName !== name
                    );
                }

                return { invalidInputFields: nextInvalidInputFields };
            },
            () => {
                this.props.onValidate && this.props.onValidate(this.state.invalidInputFields);
            }
        );
    }

    validate(showErrors, callback) {
        this.setState({ invalidInputFields: [] }, () => {
            const { inputFields, invalidInputFields } = this.state;
            Object.keys(inputFields).forEach((name) => inputFields[name].validate(showErrors));

            if (Object.keys(inputFields).length === 0 && invalidInputFields.length === 0) {
                this.props.onValidate && this.props.onValidate([]);
            }

            callback && callback();
        });
    }

    render() {
        const { children, className } = this.props;
        const initialContext = {
            addInputField: (inputField) => {
                this.setState((state) => {
                    return {
                        inputFields: {
                            ...state.inputFields,
                            [inputField.name]: inputField,
                        },
                    };
                });
            },
            onValidate: this.onValidateHandler,
            removeInputField: (inputField) => {
                this.setState(
                    (state) => {
                        const nextInputFields = { ...state.inputFields };
                        const nextInvalidInputFields = state.invalidInputFields.filter(
                            (name) => name !== inputField.name
                        );
                        delete nextInputFields[inputField.name];

                        return {
                            inputFields: nextInputFields,
                            invalidInputFields: nextInvalidInputFields,
                        };
                    },
                    () => this.validate(false)
                );
            },
        };

        return (
            <FormContext.Provider value={initialContext}>
                <form className={classNames(['kmx-form', className])}>{children}</form>
            </FormContext.Provider>
        );
    }
}

Form.contextType = FormContext;

export default Form;
